import {v4} from "uuid";
import React from "react";

export default function ToggleComponent(props) {
  const id = `cc${v4()}`;
  return (<div className="custom-control my-1 custom-switch">
    <input
      type="checkbox"
      className="custom-control-input"
      id={id}
      checked={props.checked}
      onChange={props.onChange}
    />
    <label className="custom-control-label" htmlFor={id}>
      {props.children}
    </label>
  </div>);
}
